import React from 'react';
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {Form as FormLayout} from "react-bootstrap";
import TextInput from "../../../../../Common/components/text-input";
import {formatFormTitle, FormikMultiFormSync} from "../../../../../../util/Helpers";
import SelectInput from "../../../../../Common/components/select-input";

function PersonalInformation(
    {
        dataKey,
        title,
        isEditable,
        initialValues: {
            personalData = {}
        },
    }
) {
    const maxBirthDate = new Date();
    maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 18);

    const minBirthDate = new Date();
    minBirthDate.setFullYear(minBirthDate.getFullYear() - 100);

    const validationSchema = Yup.object({
        gender: Yup.string().required('Required'),
        marital: Yup.string(),
        birth: Yup.date().max(maxBirthDate, "User is too young.").min(minBirthDate, "User is too old.").required('Required'),
        politicallyExposedNames: Yup.string(),
    })

    let birth = [personalData?.birthYear, personalData?.birthMonth?.toString().padStart(2, '0'), personalData?.birthDay?.toString().padStart(2, '0')].join("-")

    const compiledInitialValues = {
        gender: "",
        marital: "",
        politicallyExposedNames: "",
        birth,
        ...personalData
    }

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={compiledInitialValues}
                validateOnMount={true}
                enableReinitialize={true}
            >
                {({isValid}) =>
                    <Form>
                        <fieldset disabled={!isEditable}>
                            {formatFormTitle({title, isValid})}
                            <FormLayout.Row>
                                <SelectInput
                                    label="Gender*"
                                    name="gender"
                                    options={["Male", "Female"]}
                                />
                                <SelectInput
                                    label="Marital Status"
                                    name="marital"
                                    options={["SINGLE", "DIVORCED", "MARRIED", "WIDOWED", "PARTNER"]}
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Date of Birth*"
                                    name="birth"
                                    type="date"
                                    max={maxBirthDate.toISOString().split('T')[0]}
                                    min={minBirthDate.toISOString().split('T')[0]}
                                />
                                <TextInput
                                    label="Politically Exposed To"
                                    name="politicallyExposedNames"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <FormikMultiFormSync name={dataKey}/>
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default PersonalInformation;